import { t } from 'i18next'

export const getSickLeaveStatuses = () => ({
	1: t('sickLeave.open'),
	2: t('sickLeave.continue'),
	3: t('sickLeave.close'),
	4: t('sickLeave.deleted'),
})
